<ccl-context-wrapper>
    <ccl-side-navbar [navLinks]="navLinks"></ccl-side-navbar>
    <ccl-page-wrapper [contentClass]="'o-page-wrapper__content--large wrapper-width'">
        <flash-messages></flash-messages>
        <router-outlet></router-outlet>
    </ccl-page-wrapper>
</ccl-context-wrapper>